import { yellow600, blue800, red900} from 'material-ui/styles/colors';


export const styleLogin = {
    styleText: {
        margin: 10,
    },
    styleCol: {
        top: "25%",
        position: 'absolute',
    },
    styleImg: {
        width: "30%",
        height: "100%",
        marginLeft: "-10%"
    },
    styleBtn: {
        marginTop: 10
    },
    stylesIcon: {
        position: 'relative',
        left: '60%',
        top: '56%',
        color: '#686c7a'
    }
}

export const styleDashboard = {
    slide: {
        padding: 10,
    },
    bgTab: {
        backgroundColor: blue800
    },
    bgItemTab: {
        backgroundColor: '#e2e2e2'
    },
    colorTab: {
        color: 'grey'
    },
    iconAppBarRight: {
        color: 'white',
        marginTop: '60%'
    },
}

export const styleUser = {
    iconEdit: {
        height: 18,
        width: 18
    },
    iconHoverColor: {
        colorEdit: blue800,
        colorRemove: red900
    },
    tooltipEdit: {
        top: '20%',
        left: '70%'
    },
    btnAddUser: {
        position: 'relative',
        top: '40%'
    }
}


// WEBPACK FOOTER //
// ./src/components/users/style.js